import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ClaroSDKService } from '../../../services/sdk/ClaroSDKService';
import { executeTaggeo, setAddCardFormData } from '../../../store/actions';

const PaymentMethodsList = (props) => {

	const [isLoadingForm, setIsLoadingForm] = React.useState(false);
	const [imgClaroPay, setImgClaroPay] = React.useState(`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_claro_pay_0_mb.png`);

	const handleContinue = () => {
		// Taggeo
		const payment_method = props.addCardFormData.paymentMethodSelected === "claro-pay"
			? "N2"
			: "Tarjeta";

		props.executeTaggeo({
			step: "Formulario de pago",
			action: "Click modal " + payment_method,
			modal_id: "Elige método de pago"
		});

		if (props.addCardFormData.paymentMethodSelected === "credit-card") {
			setIsLoadingForm(true);

			setTimeout(() => {
				props.setAddCardFormData({ ...props.addCardFormData, isOpenAddCardForm: true });
			}, 500);
		}

		if (props.addCardFormData.paymentMethodSelected === "claro-pay") {
			props.handleCloseSelectCardAnonimous();

			if (!props.isAnonimous) {
				setTimeout(() => {
					ClaroSDKService.openOnBoarding();
				}, 500);
			} else {
				if (!props.msisdn) {
					ClaroSDKService.openLogin();
				} else {
					props.handleOpenModalCardHE();
				}	
			}
					
		}		
	}

	React.useEffect(() => {
		setIsLoadingForm(false);
	}, [props.addCardFormData.isOpenAddCardForm]);

	React.useEffect(() => {
		if (props.planCategory && (props.planCategory === 4 || props.planCategory === 3)) {
			if (props.planBenefits && props.planBenefits === 200) {
				setImgClaroPay(`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_claro_pay_200_mb.png`)
			}
			if (props.planBenefits && props.planBenefits === 500) {
				setImgClaroPay(`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_claro_pay_500_mb.png`)
			}
		}
	}, [])

	React.useEffect(() => {

		if (props.isOpen) {
			setTimeout(() => {
				props.executeTaggeo({
					step: "Formulario de pago",
					action: "View modal",
					modal_id: "Elige método de pago"
				});
			}, 500);			
		}
		
	}, [props.isOpen])

	React.useEffect(() => {
		if (props.addCardFormData.paymentMethodSelected) {
			handleContinue();
			props.setAddCardFormData({ ...props.addCardFormData, paymentMethodSelected: undefined })
		}
	}, [props.addCardFormData.paymentMethodSelected])

	return (
		<div style={{ overflow: 'scroll', height: "100%", width:'100%', position: "relative" }}>
			<p style={{
				fontFamily: 'AMX-Regular',
				fontSize: '28px',
				color: '#222222',
				margin: '0px 0px 19px 0px',
				textAlign: 'center',
			}}>
				Ahora elige<br />
				tu método de pago
			</p>

			{/* Loading */}
			{
				isLoadingForm &&
				<div style={{
					height: "150px",
					width: "100%",
					background: "rgba(246,246,246,0.3)",
					position: "absolute",
					left: "0px",
					zIndex: "2",
					display: "flex",
					alignItems: "center",
					justifyContent: "center"
				}}>
					<img src='https://logos.wokko.io/ClaroPayLoading2.gif' width="45" height="45" />
				</div>
			}
			

			{/* Option 1 - Claro pay */}
			<div style={{
				backgroundColor: "#ffffff",
				borderRadius: "4px",
				boxShadow: "0px 2px 4px 0px #fafafa, 0px 2px 2px 0px #b6b6b6",
				marginBottom: "25.4px",
				padding: "0px",
				height: "57.6px",
				display: "flex",
				zIndex: "1"
			}}
			onClick={() => props.setAddCardFormData({ ...props.addCardFormData, paymentMethodSelected: "claro-pay" })}>
				<div style={{
					padding: "0px 16px 0px 16px",
					display: "flex",
					alignItems: "center",
					height: "57.6px",
					width: "100%"
				}}>
					<img
						src={ imgClaroPay }
						style={{ maxWidth: "100%" }} />
				</div>
			</div>

			{/* Option 2 - Credit card */}
			<div style={{
				backgroundColor: "#ffffff",
				borderRadius: "4px",
				boxShadow: "0px 2px 4px 0px #fafafa, 0px 2px 2px 0px #b6b6b6",
				marginBottom: "57.4px",
				padding: "0px",
				height: "57.6px",
				display: "flex",
				zIndex: "1"
			}}
			onClick={() => props.setAddCardFormData({ ...props.addCardFormData, paymentMethodSelected: "credit-card" })}>
				<div style={{
					padding: "0px 16px 0px 16px",
					display: "flex",
					alignItems: "center",
					height: "57.6px",
					width: "100%"
				}}>
					<img
						src={`${process.env.REACT_APP_IMAGES_CONTAINER_TELCEL}gr_fico_visa_y_mastercard.png`}
						style={{ maxWidth: "100%" }} />					
				</div>
			</div>
		</div>
	)
}

const mapStateToProps = (state) => {
    const { payments } = state;
	const msisdn = payments.PAYMENT_SERVICE_CONF.msisdn;
	const addCardFormData = payments.addCardFormData;
	const isAnonimous = payments.isAnonimous;

    return {
        msisdn,
		addCardFormData,
		isAnonimous
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            setAddCardFormData,
			executeTaggeo
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodsList)